import {createGlobalStyle} from 'styled-components';

const GlobalCSSVariables = createGlobalStyle`
    // "env(safe-area-inset-*)" must be assigned to global CSS variables
    // before their values can be read with JS.
    // https://benfrain.com/how-to-get-the-value-of-phone-notches-environment-variables-env-in-javascript-from-css/

    :root {
        --sat: env(safe-area-inset-top);
        --sab: env(safe-area-inset-bottom);
    } 
`;

export default GlobalCSSVariables;
